var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    d: "M1 1h9v9H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    d: "M1 11h9v9H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    d: "M11 1h9v9h-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    d: "M11 11h9v9h-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.73fbbf647ac0c6cddbeb9c823a97df8d.svg";
export { ForwardRef as ReactComponent };